import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { Flex } from "@similarweb/ui-components/foundations";

const FOOTER_HEIGHT = "56px";

export const StyledFooter = styled(Flex)`
    justify-content: center;
    align-items: center;
    width: 100%;
    height: ${FOOTER_HEIGHT};
    flex-shrink: 0;
    padding: 8px 0;

    border-top: 1px solid ${colorsPalettes.bluegrey[200]};
    background: ${colorsPalettes.carbon[0]};

    box-sizing: border-box;
`;
